import styled from "styled-components";
import { Select, Radio, Input } from "antd";

// custom components
import Modal from "common/modal";

const { TextArea } = Input;

export const CustomModalOneOnOne = styled(Modal)`
  &.ant-modal {
    width: 544px !important;
  }
`;

export const FormInputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalSelect = styled(Select)`
  width: 100%;
  height: 60px;
  margin: 10px 0px;
  font-size: 16px;
  color: black;

  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    background-color: #f6f6f6;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: #707070;
  }

  & .ant-select-arrow {
    margin-right: 8px;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;

export const SelectCity = styled(Radio.Group)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  align-items: center;

  & .ant-radio-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 0px;
  }

  span.ant-radio + * {
    padding: 0px;
    background-color: #1070b6;
    color: white;
    font-size: 10px;
    font-weight: bold;
    height: 20px;
    width: 20px;
    margin-left: 6px;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .ant-radio .ant-radio-inner {
    width: 28px;
    height: 28px;
    border-color: #707070;
    border-width: 2px;
  }

  & .ant-radio-inner::after {
    margin: 1px;
    width: 16px;
    height: 16px;
  }
`;

export const SelectTailorMade = styled(Radio.Group)`
  height: 36px;
  display: flex;
  flex-direction: row;
  margin: 4px 0px 10px;

  & .ant-radio-button-wrapper {
    height: 100%;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #707070;
    padding: 0px 4px;
  }

  & .ant-radio-button-wrapper-checked {
    background-color: #1070b6;
    color: white;
  }
`;

export const StudentNote = styled(TextArea)`
  padding: 16px;
  background-color: #f6f6f6;
  margin: 10px 0px;
  font-size: 16px;
  color: black;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
`;

export const CreditInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 11.5px;
  margin-top: 12px;
  margin-bottom: 4px;
  & span {
    text-align: center;
  }

  // desktop
  @media only screen and (min-width: 768px) {
    & {
      text-align: left;
    }

    & span {
      text-align: left;
    }
  }
`;

export const Contact = styled.div`
  font-size: 11.5px;
  margin-top: 12px;
  margin-bottom: 12px;
  text-align: center;

  & span {
    color: #1070b6;
  }

  // desktop
  @media only screen and (min-width: 768px) {
    & {
      text-align: left;
    }
  }
`;
